import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {parseEntityCardProps} from './entity-card.library';
import {EntityCard} from './entity-card';

export const entityCardRegistration = defineStreamComponentRegistration(StreamComponentType.ENTITY_CARD, EntityCard, parseEntityCardProps);
